import React, {Component} from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import * as actions from '../../actions'

const form = reduxForm({
  form: 'signin',
})

class Signin extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  handleFormSubmit(formProps) {
    this.props.signinUser(formProps)
  }

  componentWillMount() {
    const token = localStorage.getItem('token')
    if (token !== null) {
      // TODO: Also need a verify token API endpoint to do this properly
      this.context.router.push('/dashboard')
    }
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Oops!</strong> {this.props.errorMessage}
        </div>
      )
    }
  }

  render() {
    const {handleSubmit} = this.props

    return (
      <div className="row">
        <br />
        <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
          <input type="hidden" name="ENV" value={process.env.NODE_ENV} />
          <input
            type="hidden"
            name="API_URL"
            value={process.env.REACT_APP_EF_API_URL}
          />
          <div className="col-sm-3" />
          <div className="form-group col-sm-6">
            <fieldset className="form-group">
              <Field
                name="email"
                component="input"
                type="email"
                placeholder="Email"
                className="form-control"
              />
            </fieldset>
            <fieldset className="form-group">
              <Field
                name="password"
                component="input"
                type="password"
                placeholder="Password"
                className="form-control"
              />
            </fieldset>
            {this.renderAlert()}
            <button action="submit" className="btn btn-success">Sign in</button>
          </div>
          <div className="col-sm-3" />
        </form>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    errorMessage: state.auth.error,
  }
}

export default connect(mapStateToProps, actions)(form(Signin))



/** WEBPACK FOOTER **
 ** ./src/components/auth/signin.js
 **/